import React from 'react';
import { scoreMeta } from '../lib/scoring';
import { scoreColor, scoreBand } from '../lib/format';

const Bar = ({ value }) => {
  const c = scoreColor(value);
  return (
    <div className="w-full h-2 rounded-full bg-brand-border overflow-hidden">
      <div className={`h-full score-bar-fill ${c.bg}`} style={{ width: `${Math.max(3, value)}%` }} />
    </div>
  );
};

export const ScorePanel = ({ scores, compact = false, showOverallOnly = false }) => {
  const c = scoreColor(scores.overall);
  return (
    <div className={`bg-white rounded-xl border border-brand-border ${compact ? 'p-4' : 'p-5'} shadow-sm`}>
      <div className="flex items-baseline justify-between mb-1">
        <div className="text-xs font-semibold uppercase tracking-wider text-muted-foreground">Overall MRI Score</div>
        <div className={`text-[11px] font-semibold ${c.text}`}>{scoreBand(scores.overall)}</div>
      </div>
      <div className="flex items-end gap-2">
        <div className={`text-5xl font-bold leading-none ${c.text}`}>{scores.overall}</div>
        <div className="text-sm text-muted-foreground pb-1">/ 100</div>
      </div>
      <div className="mt-2 mb-4"><Bar value={scores.overall} /></div>
      <p className="text-[10px] text-muted-foreground leading-snug border-t border-brand-border pt-3">
        This score is an awareness indicator based on client-provided data. It is not an investment rating or financial health certificate.
      </p>

      {!showOverallOnly && (
        <div className="mt-4 space-y-3">
          {scoreMeta.map((m) => {
            const v = scores[m.key] || 0;
            const cc = scoreColor(v);
            return (
              <div key={m.key}>
                <div className="flex items-center justify-between text-xs mb-1">
                  <span className="text-brand-indigo font-medium">{m.label}</span>
                  <span className={`font-semibold ${cc.text}`}>{v}</span>
                </div>
                <Bar value={v} />
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default ScorePanel;
